import React from "react";
import Select from "react-select";

class AddUserModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.modalRef = React.createRef();
    this.state = {
      username: "",
      user_email: "",
      user_password: "",
      value: null,
    };
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.onOutsideClick);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.onOutsideClick);
  }
  onChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleChangeAdminType = (value) => {
    this.setState({
      value: value,
    });
  };
  addUser = async () => {
    try {
      const { username, user_email, user_password, value } = this.state;
      const { addUser } = this.props;
      // Note: ensure that the admin type is only passed in when adding new admins on /brand-admins
      await addUser(username, user_email, user_password, value);
      this.resets();
    } catch (err) {
      console.log("addUser error", err);
    }
  };
  isInvalidInput = () => {
    const { username, user_email, user_password, value } = this.state;
    const isInvalid =
      !username.trim() || !user_email.trim() || !user_password.trim() || !value;
    return isInvalid;
  };
  resets = () => {
    this.setState({
      username: "",
      user_email: "",
      user_password: "",
      value: null,
    });
  };
  onOutsideClick = (e) => {
    if (!this.modalRef.current.contains(e.target)) {
      this.resets();
    }
  };
  render() {
    const { username, user_email, user_password, value } = this.state;
    const { hex, white, adminOptions } = this.props;
    return (
      <div
        className="modal fade"
        id="add_user"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content" ref={this.modalRef}>
            <div className="modal-header">
              <h5 className="modal-title">Add User</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.resets}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  name="username"
                  placeholder="First Name"
                  onChange={this.onChangeHandler}
                  value={username}
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  placeholder="Email"
                  name="user_email"
                  onChange={this.onChangeHandler}
                  value={user_email}
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  placeholder="Password"
                  name="user_password"
                  onChange={this.onChangeHandler}
                  value={user_password}
                />
              </div>
              <div className="form-group">
                <Select
                  inputProps={{
                    autoComplete: "random-string",
                    autofill: "off",
                  }}
                  placeholder="Type"
                  className="select"
                  value={value}
                  onChange={(value) => this.handleChangeAdminType(value)}
                  options={adminOptions}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-brand-hex btn-white"
                style={{
                  "--hover-text-color": white ? "white" : "black",
                  "--hover-color": hex,
                  backgroundColor: "white",
                  color: "black",
                }}
                data-dismiss="modal"
                onClick={this.resets}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-green"
                data-dismiss="modal"
                onClick={this.addUser}
                disabled={this.isInvalidInput()}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddUserModal;



// WEBPACK FOOTER //
// ./src/components/AddUserModal/index.js